import { render, staticRenderFns } from "./tab_bar.vue?vue&type=template&id=6f9bce39&scoped=true"
import script from "./tab_bar.vue?vue&type=script&lang=js"
export * from "./tab_bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9bce39",
  null
  
)

export default component.exports